/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import get from 'lodash/get';
import { getPermitType } from './getPermitType';

export const getHuntingDivisions = (permit = {}, huntType = '', divisionId = '') => {
    const permitType = getPermitType(permit, huntType);
    if (permitType?.open) {
        if (Array.isArray(permitType.divisions)) {
            return permitType.divisions
                .map((id) => get(permit, ['divisions', id, 'name'], id))
                .join(', ');
        }
        return 'Open Hunt';
    }
    return permit.divisions?.[divisionId]?.name ?? divisionId;
};
